import { render, staticRenderFns } from "./NewInventory.vue?vue&type=template&id=23621e94&"
import script from "./NewInventory.vue?vue&type=script&lang=js&"
export * from "./NewInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports